import { ActivityDirection, AiFileActivityId, InfoCategoryId } from "./model";

/**
 * The filters behind the number the user clicked, carried out-of-band.
 *
 * The events modal's coordinates can express severity (AxisType.Severity) but
 * neither the AI relation nor the gen-ai category — AxisType has no member for
 * either. Until the backend ships the AiContentRelation axis, the drill-down
 * records them here and `src/mock/api/gen-ai.mock.ts` reads them back when it
 * serves the rows, so the list really is filtered by what produced the number
 * rather than only naming it in the title.
 *
 * Every gen-ai entry point into EventsModal sets this — including to null —
 * so a previous drill-down's scope can never leak into the next one.
 */
/**
 * Which card was clicked. Each widget has its own event set in the
 * final-copilot-mock-data package — the severity card's 261 interactions and
 * the matrix's 7,792 are different populations, not one list sliced two ways —
 * so the mock has to know which file to read, not just how to filter it.
 */
export type GenAiDrillWidget =
  | "severity"
  | "risk-category"
  | "accessed"
  | "matrix"
  | "sample";

export interface GenAiDrillScope {
  widget?: GenAiDrillWidget;
  relation?: AiFileActivityId;
  /**
   * Which Risks card the number came from: employee -> AI or AI -> content.
   * The two are different populations (gen-ai-ui is explicit they "are not the
   * same"), so a drill-down from one must not list the other's activity.
   */
  direction?: ActivityDirection;
  category?: InfoCategoryId;
  /** an employee's address, for "this person's events" */
  actor?: string;
  /** the same person's employee entity id, which the live events list filters on */
  actor_id?: string;
  /**
   * The classification cards' slider position (3=High .. 0=None).
   *
   * Data sensitivity, not risk severity — a different axis. It travels
   * out-of-band with the rest of the scope because the events modal has no
   * sensitivity control of its own, so nothing downstream can contradict it.
   */
  sensitivities?: number[];
}

let scope: GenAiDrillScope | null = null;

export const set_gen_ai_drill_scope = (s: GenAiDrillScope | null) => {
  scope = s;
};

export const get_gen_ai_drill_scope = () => scope;
